import { CatalogData } from "../../data/catalogData";
/**
 * Время клиента в формте для отправки на сервер.
 * @returns строка времени в формате yyyy/MM/dd HH:mm:SS
 */
export function clientTime(): string {
  const now = new Date();
  const year = now.getFullYear().toString();
  let month = (now.getMonth() + 1).toString();
  let day = now.getDate().toString();
  let hour = now.getHours().toString();
  let minute = now.getMinutes().toString();
  let second = now.getSeconds().toString();
  if (month.toString().length == 1) {
    month = "0" + month;
  }
  if (day.toString().length == 1) {
    day = "0" + day;
  }
  if (hour.toString().length == 1) {
    hour = "0" + hour;
  }
  if (minute.toString().length == 1) {
    minute = "0" + minute;
  }
  if (second.toString().length == 1) {
    second = "0" + second;
  }

  return (
    year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second
  );
}

/**
 * Получить случайное целое число
 * @param min Минимальный предел диапазона
 * @param max Максимальный предел диапазона
 * @returns 0Дата в американском формате
 */
export function getRandInt(min: number, max: number): number {
  return min + Math.floor((max - min) * Math.random());
}

export function isStringEmpty(str: any): boolean {
  if (typeof str === 'string')
    return str.trim() === "";
  return false;
}

/**
 * Получение времени дня.
 * @returns morning, day, evening или night.
 */
export function getPeriodOfDay(): string {
  const now = new Date();
  const hours = now.getHours();

  let timeOfDay = "";

  if (hours >= 4 && hours < 12) {
    timeOfDay = "morning";
  } else if (hours >= 12 && hours < 16) {
    timeOfDay = "day";
  } else if (hours >= 16 && hours < 23) {
    timeOfDay = "evening";
  } else if (hours >= 23 || hours < 4) {
    timeOfDay = "night";
  }

  return timeOfDay;
}

/**Деэкранирование xml */
export function decodeXml(text: string): string {
  text = text.replaceAll("&lt;", "<");
  text = text.replaceAll("&gt;", ">");
  text = text.replaceAll("&amp;", "&");
  text = text.replaceAll("&quot;", '"');
  text = text.replaceAll("&#x60;", "`");
  text = text.replaceAll("<a", '<a target="_blank" ');
  return text;
}

export function jsUcfirst(val: string): string {
  return val.charAt(0).toUpperCase() + val.slice(1);
}



/**
 * Поиска в каталоге по id
 * @param catalog Родительский каталог для поиска нужного каталога
 * @param id идентификатор операции
 * @return каталог с нужным идентификатором
 */
export function searchCatalogById(catalog: CatalogData, id: string | number) {
  /** Если родительский каталог является нужным */
  if (catalog.Id == id)
    return catalog;

  let res = null;

  /** Если родительский каталог не является нужным бежим по его детям */
  const rest = catalog.Childrens.find((child) => {
    /** Если айди совпадает возвращаем элемент */
    if (child !== null && child.Id == id) {
      return true;
      /** Если айди не совпадает и у каталога есть дети вызываем данный метод для него, возвращаемое значение запоминаем, так как find вернет не его а сам роидтельский элемент */
    } else if (child.CatalogType === 0) {
      res = searchCatalogById(child, id);
      return res ? true : false;
    }
  });


  /** Если значение res не запомнило ни одного элемента значит возвращаем то что нашел метод find */
  return !res ? rest : res;
}

/**
 * Проверка актуальности веб клиента 
 * @param serverVer Версия сервера
 * @param clientVer Версия клиента
 */
 export function checkVersion(serverVer: string, clientVer: string): boolean {
  const servArr: Array<string> = serverVer.split('.');
  const clientArr: Array<string> = clientVer.split('.');
  let flag: boolean = true;
  for (let i = 0; i < servArr.length; i++) {
    if (parseInt(servArr[i]) < parseInt(clientArr[i])) {
      flag = true;
      break;
    } else if (parseInt(servArr[i]) > parseInt(clientArr[i])) {
      flag = false;
      break;
    }
  }
  return !serverVer || !clientVer || flag;
}

export function versionToInt(version: string): number {
  version = version.replace(/[^\d]/gi, "")
  return parseInt(version)
}

export function replaceByTemplate(values: any, template: string): string {
  let result: string = template;
  for (const key in values) {
    if (values[key]) {
      result = result.replace(`{${key}}`, values[key]);
    }
  }

  return result;
}

export function getValueByKey(obj: any, key: any): any {
  let result: any = '';
  if (obj) {
    for (const k in obj) {
      if (k === key) {
        result = obj[k];
      }
    }
  }
  return result;
}

export function urlFilter(baseUrl: string, url: string): string {
  if (!url)
  	return ""
  if (url.trim() === "" || url.length <= 4 || url.startsWith("http"))
    return url
  
  if(!baseUrl) {
    baseUrl = "/"
  }
  return url.startsWith("/") ? baseUrl + url.substring(1) : baseUrl + url
}
